<div *ngIf="isOpen" class="workflow-modal" role="dialog" aria-modal="true">
  <div class="workflow-modal__backdrop" (click)="close()"></div>

  <!-- Modal Card -->
  <div
    class="workflow-modal__card relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-[560px] mx-4 animate-modal-in overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Close Button -->
    <button
      (click)="close()"
      class="absolute top-4 right-4 w-8 h-8 bg-red-500 hover:bg-red-600 active:scale-95 transition-all duration-150 rounded-lg flex items-center justify-center shadow-md z-20"
      aria-label="Close modal"
    >
      <svg
        class="w-4 h-4 text-white"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <!-- Scrollable Body -->
    <div class="overflow-y-auto max-h-[90vh] px-8 pt-8 pb-6">
      <!-- Header -->
      <div class="mb-6">
        <h2
          class="text-[1.6rem] font-bold text-gray-800 tracking-tight leading-tight"
        >
          {{ 
            (mode === "CREATE" && "New Workflow") ||
            (mode === "UPDATE" && "Update Existing Workflow") ||
            (mode === "VIEW" && "View Workflow") 
          }}
        </h2>
        <p class="text-sm text-gray-400 mt-0.5 font-medium">
          {{
            (mode === "CREATE" && "Create approval workflow for applications") ||
            (mode === "UPDATE" && "Update existing approval workflow for applications") ||
            (mode === "VIEW" && "View Workflow for applications")
          }}
        </p>
      </div>

      <!-- Form -->
      <form [formGroup]="workflowForm" (ngSubmit)="saveWorkflow()" novalidate>
        <!-- Row 2: Zone + Tax Office -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-7">
          <div class="flex flex-col gap-1">
            <label
              class="text-xs font-semibold text-gray-600 tracking-wide uppercase"
              >Workflow Name</label
            >
            <div class="relative">
              <select
                formControlName="name"
                class="w-full appearance-none border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 pr-9 cursor-pointer disabled:cursor-not-allowed"
              >
                <option value="" disabled selected>-- Select Option --</option>
                <option
                  *ngFor="let office of workflowName"
                  [value]="office.value"
                >
                  {{ office.label }}
                </option>
              </select>
              <span
                class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label
              class="text-xs font-semibold text-gray-600 tracking-wide uppercase"
              >Mda</label
            >
            <div class="relative">
              <select
                formControlName="mdaId"
                class="w-full appearance-none border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 pr-9 cursor-pointer disabled:cursor-not-allowed"
              >
                <option value="" disabled selected>-- Select Option --</option>
                <option *ngFor="let zone of mdaList?.data" [value]="zone.id">
                  {{ zone.name }}
                </option>
              </select>
              <span
                class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div class="md:col-span-2 flex flex-col gap-1">
            <label
              class="text-xs font-semibold text-gray-600 tracking-wide uppercase"
              >Description</label
            >
            <textarea 
              [appCharLength]
              formControlName="description"
              placeholder="Enter Workflow Description"
              class="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 disabled:cursor-not-allowed">
            </textarea>
          </div>
        </div>
        <!-- Workflow Steps Section -->
        <div class="mb-5">
          <h3
            class="text-base font-bold text-gray-800 border-b-2 border-gray-800 pb-1 inline-block mb-4"
          >
            Workflow Steps
          </h3>

          <!-- Steps Fields -->
           @if (mode !== "VIEW") {
             <div [formGroup]="stepForm">
               <!-- Row: Approving Officer + Step Number -->
               <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <!-- Approving officer -->
                 <div class="flex flex-col gap-1">
                   <label
                     class="text-xs font-semibold text-gray-600 tracking-wide uppercase"
                     >Approving Officer</label
                   >
                   <div class="relative">
                     <select
                       formControlName="userId" 
                       class="w-full appearance-none border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 pr-9 cursor-pointer disabled:cursor-not-allowed"
                     >
                       <option value="" disabled selected>
                         -- Select Option --
                       </option>
                       <option
                         *ngFor="let officer of filteredAdmin"
                         [value]="officer.id"
                       >
                         {{ officer.full_name }}
                       </option>
                     </select>
                     <span
                       class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                     >
                       <svg
                         class="w-4 h-4"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         viewBox="0 0 24 24"
                       >
                         <path
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           d="M19 9l-7 7-7-7"
                         />
                       </svg>
                     </span>
                   </div>
                 </div>
                 <!-- Step Number -->
                 <div class="flex flex-col gap-1">
                   <label
                     class="text-xs font-semibold text-gray-600 tracking-wide uppercase"
                     >Step Number</label
                   >
                   <div class="relative">
                     <select
                       formControlName="stepOrder"
                       class="w-full appearance-none border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 pr-9 cursor-pointer disabled:cursor-not-allowed"
                     >
                       <option value="" disabled selected>
                         -- Select Option --
                       </option>
                       <option *ngFor="let step of stepNumbers" [value]="step">
                         {{ step }}
                       </option>
                     </select>
                     <span
                       class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                     >
                       <svg
                         class="w-4 h-4"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         viewBox="0 0 24 24"
                       >
                         <path
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           d="M19 9l-7 7-7-7"
                         />
                       </svg>
                     </span>
                   </div>
                 </div>
                 <!-- Row: Action + Add Step Button -->
                 <div class="flex flex-col gap-1">
                   <label class="text-xs font-semibold text-gray-600 tracking-wide uppercase">Action</label>
                   <div class="relative">
                     <select
                       formControlName="onApproval"
                       class="w-full appearance-none border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400/50 focus:border-teal-400 transition-all duration-200 bg-gray-50/60 pr-9 cursor-pointer disabled:cursor-not-allowed"
                     >
                       <option value="" disabled selected>
                         -- Select Option --
                       </option>
                       <option
                         *ngFor="let action of actions"
                         [value]="action.value"
                       >
                         {{ action.label }}
                       </option>
                     </select>
                     <span
                       class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                     >
                       <svg
                         class="w-4 h-4"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         viewBox="0 0 24 24"
                       >
                         <path
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           d="M19 9l-7 7-7-7"
                         />
                       </svg>
                     </span>
                   </div>
                 </div>
                 
                 <!-- Add Step Button -->
                 <div class="flex flex-col justify-end">
                   @if (isEditingStep) {
                    <div class="flex items-center gap-3 ">
                      <button
                        type="button"
                        (click)="completeStepEdit()"
                        class="w-full page-btn page-btn-primary active:scale-[0.98] text-white font-semibold text-sm text-nowrap px-4 py-2.5 rounded-lg flex items-center justify-center gap-2 transition-all duration-200"
                      >
                        Edit Step
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2.5"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M13 7l5 5-5 5M6 12h12"
                          />
                        </svg>
                      </button>

                      <!-- Remove Step Button -->
                      <button
                        type="button"
                        (click)="exitStepEdit()"
                        class="max-h-full h-full px-3 border border-gray-300 text-gray-300 hover:text-red-400 hover:!border-red-400 rounded-lg transition-colors duration-150"
                        aria-label="Remove step"
                      >
                        <svg
                          class="size-5"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                   } @else {
                     <button
                       type="button"
                       (click)="addStep()"
                       class="w-full page-btn page-btn-primary active:scale-[0.98] text-white font-semibold text-sm px-5 py-2.5 rounded-lg flex items-center justify-center gap-2 transition-all duration-200"
                     >
                       Add Step
                       <svg
                         class="w-4 h-4"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2.5"
                         viewBox="0 0 24 24"
                       >
                         <path
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           d="M13 7l5 5-5 5M6 12h12"
                         />
                       </svg>
                     </button>
                   }
                 </div>
               </div>
   
             </div>
           }

          <!-- Steps Table -->
          @if (!isLoadingSteps) {
            @if (steps?.length > 0) {
              <div
                class="rounded-xl border border-gray-100 overflow-hidden"
              >
                <table class="w-full text-sm">
                  <thead>
                    <tr class="bg-gray-50 border-b border-gray-100">
                      <th
                        class="text-left px-4 py-3 font-semibold text-gray-600 text-xs uppercase tracking-wide"
                      >
                        Approving Officer
                      </th>
                      <th
                        class="text-left px-4 py-3 font-semibold text-gray-600 text-xs uppercase tracking-wide"
                      >
                        Step
                      </th>
                      <th
                        class="text-left px-4 py-3 font-semibold text-gray-600 text-xs uppercase tracking-wide"
                      >
                        Action
                      </th>
                      @if (mode !== "VIEW" && !isEditingStep) {
                        <th
                          class="px-4 py-3 text-xs uppercase tracking-wide text-gray-400 text-right"
                        >
                          <!-- Remove -->
                        </th>
                        }
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let step of steps; let i = index"
                      class="border-b border-gray-50 last:border-b-0 hover:bg-teal-50/40 transition-colors duration-150"
                    >
                      <td class="px-4 py-3 text-gray-700 font-medium">
                        {{ step.user }}
                      </td>
                      <td class="px-4 py-3 text-gray-500">{{ step.stepOrder }}</td>
                      <td class="px-4 py-3">
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-50 text-teal-700 border border-teal-100"
                        >
                          {{ step.onApproval }}
                        </span>
                      </td>
                      @if (mode !== "VIEW" && !isEditingStep) {
                        <td class="px-4 py-3 text-right">
                          <div class="flex items-center gap-3">
                            <!-- Update Step Button -->
                            <button
                              type="button"
                              (click)="editStep(i)"
                              class="cursor-pointer duration-150"
                              aria-label="Remove step"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="size-5 text-slate-400 hover:text-slate-800"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                />
                              </svg>
                            </button>
                            <!-- Remove Step Button -->
                            <button
                              type="button"
                              (click)="removeStep(i)"
                              class="text-gray-300 hover:text-red-400 transition-colors duration-150"
                              aria-label="Remove step"
                            >
                              <svg
                                class="size-5"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      }
                    </tr>
                  </tbody>
                </table>
              </div>
            } @else {
              <!-- Empty State -->
              <div
                class="rounded-xl border border-dashed border-gray-200 py-6 flex flex-col items-center justify-center text-gray-300 gap-1"
              >
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                <span class="text-xs font-medium">No steps added yet</span>
              </div>
            }
          } @else {
            <!-- Loading State -->
            <div class="px-6 py-16 text-center">
              <div class="flex flex-col items-center gap-3">
                <div
                  class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600"
                ></div>
                <p class="text-sm font-medium text-slate-500">Loading steps...</p>
              </div>
            </div>
          }
        </div>

        <!-- Save Button -->
        @if (mode === "CREATE") {
          <button
            type="submit"
            class="w-full mt-2 page-btn page-btn-primary active:scale-[0.99] text-white font-semibold text-sm py-3.5 rounded-xl flex items-center justify-center gap-2 transition-all duration-200 shadow-md shadow-teal-100"
          >
            Save Workflow
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 7l5 5-5 5M6 12h12"
              />
            </svg>
          </button>
        }
      </form>
    </div>
  </div>
</div>
